import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-980b66c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import { RouterView } from 'vue-router'
import AppLayoutHeader from './AppLayoutHeader/AppLayoutHeader.vue'
import AppLayoutSidebar from './AppLayoutSidebarMenu/AppLayoutSidebar.vue'
import AppLayoutFooter from './AppLayoutFooter.vue'
import AppLayoutFloatingMenu from './AppLayoutSidebarMenu/AppLayoutFloatingMenu.vue'
import AccPayBanner from '@/components/AccPayBanner/AccPayBanner.vue'
import { onMounted, ref } from 'vue'

const LAPTOP_MIN_SCREEN_SIZE = 768
const THRESHOLD_TO_HIDE_HEADER = 75

export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutMain',
  setup(__props) {

const showTopMenuItems = ref(false)

const isMobileLayout = ref(false)
let previousScrollY = 0
const hideHeader = ref(false)

onMounted(async () => {
  updateDesktopScreen()
})

const setScrollTop = () => {
  window.scrollTo(0, 0)
}

const setScrollingDown = () => {
  const currentScrollY = window.scrollY || window.pageYOffset

  if (currentScrollY < previousScrollY) {
    hideHeader.value = false
  } else if (currentScrollY >= THRESHOLD_TO_HIDE_HEADER) {
    hideHeader.value = true
  }
  previousScrollY = currentScrollY
}

const updateDesktopScreen = () => {
  isMobileLayout.value = window.innerWidth < LAPTOP_MIN_SCREEN_SIZE
}

window.addEventListener('scroll', setScrollingDown)
window.addEventListener('resize', updateDesktopScreen)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-container", { 'app-container-mobile': isMobileLayout.value }])
  }, [
    (!isMobileLayout.value)
      ? (_openBlock(), _createBlock(AppLayoutSidebar, {
          key: 0,
          class: "sidebar",
          onClick: setScrollTop
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(AppLayoutHeader, {
      class: _normalizeClass(["header", { 'header--hidden': hideHeader.value }]),
      "is-mobile-layout": isMobileLayout.value,
      onToggleMenu: _cache[0] || (_cache[0] = ($event: any) => (showTopMenuItems.value = !showTopMenuItems.value))
    }, null, 8 /* PROPS */, ["class", "is-mobile-layout"]),
    _createVNode(AppLayoutFooter, {
      class: "footer",
      "is-mobile-layout": isMobileLayout.value
    }, null, 8 /* PROPS */, ["is-mobile-layout"]),
    _createVNode(_unref(RouterView), {
      class: _normalizeClass(["dsf-theme-default", [
        { 'header-mf--hidden': hideHeader.value },
        { 'content--mobile': isMobileLayout.value },
      ]])
    }, {
      default: _withCtx(({ Component }: { Component: unknown }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AccPayBanner),
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class"]),
    (isMobileLayout.value && showTopMenuItems.value)
      ? (_openBlock(), _createBlock(AppLayoutFloatingMenu, {
          key: 1,
          onToggleMenu: _cache[1] || (_cache[1] = ($event: any) => (showTopMenuItems.value = !showTopMenuItems.value))
        }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})